import { Environment } from './environment.model';

export const environment: Environment = {
    name: 'dev',
    production: false,
    apiBaseUrl: 'https://v3.mentor-dev.neccton.ai/pic-demo',
    firebase: {
        apiKey: "AIzaSyDt5rVOtWwrcKlnkxe3UruxYAY31b7bgYI", //"AIzaSyBdlQ1npF7ft_NkgeTr_2UmSbVuyUeqbug",
        authDomain: "mentor-development.firebaseapp.com",
        projectId: 'mentor-nextgenui-dev',
        appId: '1:880476994727:web:37746738ee742da5382f82',
    },
    tenantId: 'DemoV3-mhxj5',
    loginProvider: {
        providerId: 'oidc.openbet',
        providerDisplayName: 'Okta',
    },
};
